define('models/AlertRule',[
    'services/liveDataService',
    'util/ObservableModel'
], function (
    liveDataService,
    ObservableModel
) {
    'use strict';

    var AlertRule = ObservableModel.extend({
        defaults: {
            name: null,
            inAlarm: false,
            enabled: false,
            mediaType: null,
            metric: null,
            alertTypes: [],
            notificationUsers: [],
            statistic: null,
            value: null,
            dimension: null,
            dimensionName: null,
            dimensionValue: null,
            numericRange: null,
            dimensionAccessible: true
        }
    }, function () {
    });

    liveDataService.registerTopic('rules', AlertRule);

    return AlertRule;
});

